<button class="btn-default" (click)="onClear()">Modifier</button>
<div class="w-full">
  <p class="text-sm font-bold tracking-wider">
    {{ person?.civilite }}
    {{ person?.lastName }}
    {{ person?.firstName }}
  </p>
</div>
